// axios
import axios from 'axios';

const domain = "https://localhost:5001/";
const apiKey = "sYBbnGNY0uMQAvq7FEsRPIRzYOcDhC2O";

export default axios.create({
  baseURL: domain,
  headers: {
    'ApiKey': apiKey,
    'Content-Type':  'application/json',
  },
});
